import { UIText3 } from '@cian/ui-kit/typography';
import * as React from 'react';
import { useSliderContext } from '../../../../utils/sliderContext';
import * as styles from './PaginationFraction.css';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var PaginationFraction = function PaginationFraction() {
  var _useSliderContext = useSliderContext(),
      currentSlide = _useSliderContext.currentSlide,
      totalSlides = _useSliderContext.totalSlides;

  if (!totalSlides) {
    return null;
  }

  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    children: /*#__PURE__*/_jsxs(UIText3, {
      color: "text-inverted-default",
      children: [currentSlide + 1, "/", totalSlides]
    })
  });
};